import Vue from "vue";
import Vuex from "vuex";
import { getCustomer } from "../../utils/apiFunctions.js";
Vue.use(Vuex);

// State
const state = () => ({
  customerDetails: [],
  customerID: "",
  CustomerCardName: "",
  sourceSelect: "",
});

// getters
const getters = {
  getsaveAllCustomer: (state) => state.customerDetails,
  getCustomerID: (state) => state.customerID,
};

// actions
const actions = {
  // GET CUSTOMER API
  async getCustomer(state, data) {
    try {
      const res = await getCustomer(data);
      if (res.status == 200) {
        let payload = res.data.data;
        state.commit("saveAllCustomer", payload);
      }
      return res;
    } catch (error) {
      return error;
    }
  },
};

// mutations
const mutations = {
  // ADD Customer
  saveCustomer(state, payload) {
    state.customerDetails.push(payload);
  },

  // GET CUSTOMER
  saveAllCustomer(state, payload) {
    state.customerDetails = payload;
  },

  //saving customerID
  savecustomerID(state, payload) {
    state.customerID = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
